import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';
import { Observable, of } from 'rxjs';
import { ISunatHistoryItem, ISunatPreviewRow } from './sunat-report.interface';

const baseRoute = '/reportes/sunat'; // Example base route

@Injectable({
    providedIn: 'root'
})
export class SunatReportService extends CrudService {
    constructor(http: HttpClient) {
        super(http, baseRoute);
    }

    exportHistory(dto: any): Observable<any> {
        return this.request({
            method: 'POST',
            url: '/export-history',
            data: dto
        });
    }

    getExportHistory(businessId: number, params: any = {}): Observable<any> {
        return this.request({
            method: 'GET',
            url: `/export-history/business/${businessId}`,
            params,
            clearCache: true
        });
    }

    getKardexPreview(
        businessId: number,
        params: any = {}
    ): Observable<HttpResponse<{ data: { items: ISunatPreviewRow[] , meta: any } }>> {
        return this.request({
            method: 'GET',
            url: `/kardex/business/${businessId}`,
            params,
            clearCache: true,
        });
    }

    downloadKardexExcel(businessId: number, periodo: string): Observable<HttpResponse<Blob>> {
        return this.request({
            method: 'GET',
            url: `/kardex/excel/${businessId}`,
            params: { periodo },
            responseType: 'blob',
            clearCache: true
        });
    }

    downloadKardexTxt(businessId: number, periodo: string): Observable<HttpResponse<Blob>> {
        return this.request({
            method: 'GET',
            url: `/kardex/txt/${businessId}`,
            params: { periodo },
            responseType: 'blob',
            clearCache: true
        });
    }

}
